import React from "react";
import "../styles/main.css";
import Navbar from "../components/Navbar";
import laptops from "../assets/3laptops.png";
import Ellipse from "../assets/Ellipse57.svg";
import "react-lazy-load-image-component/src/effects/opacity.css";
import {Link} from "react-router-dom";


const VFB_mainPage= () => {
  return (
  <div className="flex flex-col min-h-screen overflow-hidden">

  {/* BANNER SECTION */}
  <div className="relative flex-1 overflow-hidden flex flex-col">

    {/* Background - Dark gradient */}
    <div 
      className="absolute inset-0 z-0"
      style={{
        background: 'linear-gradient(135deg, #1a1a00 0%, #0d0d00 40%, #000000 100%)'
      }}
    />

    {/* Top Right Blob */}
    <div className="absolute top-[-10%] right-[0%] w-[700px] h-[700px] rounded-full opacity-40 blur-3xl pointer-events-none z-0">
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background: "radial-gradient(circle, rgba(255, 206, 0, 0.5) 10%, rgba(0, 160, 255, 0) 70%)",
        }}
      ></div>
      <img src={Ellipse} alt="Ellipse" className="absolute inset-0 w-full h-full object-contain" />
    </div>

    {/* Bottom Left Blob */}
    <div className="absolute bottom-[-15%] left-[-10%] w-[700px] h-[700px] rounded-full opacity-40 blur-3xl pointer-events-none z-0">
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background: "radial-gradient(circle, rgba(255, 206, 0, 0.5) 10%, rgba(0, 160, 255, 0) 70%)",
        }}
      ></div>
      <img src={Ellipse} alt="Ellipse" className="absolute inset-0 w-full h-full object-contain" />
    </div>

    {/* ✅ NAVBAR - inside banner with z-50 to stay on top */}
    <div className="relative z-50">
      <Navbar />
    </div>

    {/* RIGHT SIDE - Image as background overlay */}
    <div className="absolute sm:text-center bottom-0 right-0 w-[50%] xl:w-[65%] sm:w-[100%] z-10 pointer-events-none">
      <img
        src={laptops}
        alt="Vupop Dashboard"
        className="absolute bottom-0 right-0 w-full h-auto object-cover"
      />
    </div>

    {/* LEFT SIDE - Text content */}
    <div className="relative sm:text-center z-20 flex flex-col sm:justify-start justify-start flex-1 px-[7rem] sm:px-10 md:px-14 lg:px-16 xl:px-20 pt-[180px] sm:py-16">
<h1
  style={{ fontFamily: "Norwester" }}
  className="text-[72px] xl:text-[54px] lg:text-[44px] md:text-[36px] sm:text-[30px] text-[#FFF528] font-[400] leading-tight mb-4 sm:mb-3"
>
  Vupop for Broadcasters
</h1>

<p className="font-Inter text-[32px] xl:text-[24px] lg:text-[20px] md:text-[18px] sm:text-[16px] font-[600] text-white mb-4 sm:mb-3 leading-snug">
  Bring Real Fan Energy Into Sports Broadcasting
</p>

<p className="font-Inter text-[18px] xl:text-[16px] lg:text-[15px] md:text-[14px] sm:text-[13px] font-[400] text-[#ADADAD] mb-8 sm:mb-6 leading-relaxed max-w-5xl xl:max-w-2xl lg:max-w-xl md:max-w-full sm:max-w-full">
  Audiences crave emotion. They want to feel the noise, the tension and 
  the atmosphere of live sport. Vupop helps broadcasters access authentic 
  fan content that shows what sport feels like from inside the crowd.
</p>

{/* Get Started Button */}
<div>
  <Link to="https://manager.vupop.io/broadcaster/signup/subscription" target="_blank">
    <button className="font-[Norwester] bg-[#FFF528] hover:bg-[#FFF528]/70 transition-colors text-black font-[400] text-[18px] xl:text-[16px] lg:text-[15px] md:text-[14px] sm:text-[13px] uppercase px-10 xl:px-8 sm:px-6 py-2.5 sm:py-2 rounded-lg tracking-wide">
      Get Started
    </button>
  </Link>
</div>

    </div>

  </div>

</div>
  );
};

export default VFB_mainPage;